import React from 'react';
import { getValueForDevice } from '../../utils';
export { MY_ACCOUNT_VIEW_QUERY_PARAM } from './utils';

export const myAccountPlugin = {
  beforeRender({ header, params, headerRenderers }) {
    const myAccountButtonConfig = {
      type: '@myaccount/myaccount-button',
      data: {
        id: 'hrs-action__myaccount-button',
      },
      children: [],
    };

    const myAccountModalsConfig = {
      type: '@myaccount/modals',
      data: {
        id: 'pi-header__myaccount-modals',
        urls: {
          withdraw: getValueForDevice(params.withdrawUrl),
          reversalWithdraw: getValueForDevice(params.reversalWithdrawUrl),
          pokerBalanceTransfer: getValueForDevice(params.pokerBalanceTransferUrl),
        },
      },
      children: [],
    };

    header.actions.children.splice(1, 0, myAccountButtonConfig);
    header.actions.children.push(myAccountModalsConfig);

    headerRenderers.push({
      type: '@myaccount/myaccount-button',
      render: () => <div key="cp-myacc-button" id="cp-ma-wrapper" />,
    });
  },
};
